import { AppServiceFactory } from '@/modules/app/service/AppServiceFactory';
import { CanvasServiceFactory } from '@/modules/canvas/services/Canvas/CanvasServiceFactory';

import { AreaPickerServiceExceptionDecorator } from './AreaPickerServiceExceptionDecorator';
import { AreaPickerServiceImpl } from './AreaPickerServiceImpl';
import { AreaPickerServiceLogDecorator } from './AreaPickerServiceLogDecorator';
import { IAreaPickerService } from './IAreaPickerService';

export class AreaPickerServiceFactory {
  private static instance: AreaPickerServiceFactory | null = null;
  private impl: AreaPickerServiceImpl | null = null;

  public static initialize() {
    AreaPickerServiceFactory.instance = new AreaPickerServiceFactory();
  }

  public static getInstance() {
    if (AreaPickerServiceFactory.instance === null) {
      throw new Error(
        'AreaPickerServiceFactory not yet initialized. Call AreaPickerServiceFactory.initialize() first.',
      );
    }
    return AreaPickerServiceFactory.instance;
  }
  
  public createAreaPickerService(): IAreaPickerService {
    let result: IAreaPickerService = this.getOrCreateImpl();
    result = new AreaPickerServiceExceptionDecorator(result);
    result = new AreaPickerServiceLogDecorator(result);
    return result;
  }

  private getOrCreateImpl(): AreaPickerServiceImpl {
    if (this.impl === null) {
      const appSvc = AppServiceFactory.getInstance().createAppService();
      const canvasSvc = CanvasServiceFactory.getInstance().createCanvasService();
      this.impl = new AreaPickerServiceImpl(appSvc, canvasSvc);
    }
    return this.impl;
  }
}
